import styled from 'styled-components'
const MAX_PREVIEW_WIDTH = 800

export const S_InvoiceFilesModal = styled.div`
  width: ${MAX_PREVIEW_WIDTH}px;
  max-width: 100%;
`
